import {Injectable} from '@angular/core';
import {Location} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {ClipboardService} from 'ngx-clipboard';
import {Router} from '@angular/router';

@Injectable({providedIn: 'root'})
export class UtilsService {

  constructor(private _location: Location,
              private clipboardService: ClipboardService,
              private router: Router,
              private toastr: ToastrService) {
  }

  goBack = () => this._location.back();
  redirect = (link: any = '') => this.router.navigate([link]);
  toastSuccess = (msg: string, title?: string) => this.toastr.success(msg, title ?? 'Success');
  toastError = (msg: string, title?: string) => this.toastr.error(msg, title ?? 'Error');
  resErr = (err) => this.toastr.error(err.error.message ?? 'Something went wrong', 'Error');

  copyToClipboard(str: any = ''): void {
    this.clipboardService.copyFromContent(str);
  }

  deepClone(data = {}): any {
    return JSON.parse(JSON.stringify(data));
  }

  convertCurrency(amount, toINR = false): any {
    const inrToUsdRate = 0.012; // 1 INR = 0.012 USD
    const usdToInrRate = 1 / inrToUsdRate; // 1 USD = (1 / inrToUsdRate) INR
    const result = toINR ? amount * usdToInrRate : amount * inrToUsdRate;
    return result.toFixed(2);
  }
}
